import React from "react";
import { ArrowLink } from "@/portal/ui/Layout";

/** Panou standard al paginii Acasă: icon + titlu + „Vezi toate →”. */
export function HomePanel({ icon: Icon, title, to, linkLabel = "Vezi toate", children, className = "", testid, bodyClass = "" }) {
  return (
    <section className={`cp-panel flex flex-col min-w-0 ${className}`} data-testid={testid} aria-label={title}>
      <header className="flex items-center gap-2.5 px-5 pt-4 pb-2.5">
        {Icon && <Icon className="h-[17px] w-[17px] text-cp-text-2 shrink-0" aria-hidden="true" />}
        <h2 className="cp-h3 flex-1 min-w-0 truncate">{title}</h2>
        {to && <ArrowLink to={to} testid={testid ? `${testid}-all` : undefined}>{linkLabel}</ArrowLink>}
      </header>
      <div className={`px-5 pb-4 flex-1 min-w-0 ${bodyClass}`}>{children}</div>
    </section>
  );
}

export function PanelEmpty({ icon: Icon, text, tone = "" }) {
  return (
    <div className="h-full min-h-[120px] flex flex-col items-center justify-center text-center py-4" data-testid="panel-empty">
      {Icon && <span className={`cp-tile ${tone ? `is-${tone}` : "is-neutral"} mb-2`}><Icon /></span>}
      <p className="cp-body-sm max-w-[220px]">{text}</p>
    </div>
  );
}
